// assets/volume-discount-banner.js
// JavaScript for Volume Discount Banners in Cart Drawer.
// Handle animations and dynamic updates in the cart.

(function() {
  /**
   * Initialize all banners when the cart or a relevant section is loaded.
   * Dawn re-renders the cart-drawer section on every item update, so
   * the primary task here is to handle visual enhancements like
   * progress bars or animations after each render.
   */
  function initVolumeDiscountBanners() {
    const banners = document.querySelectorAll('.vd-banner');
    
    banners.forEach((banner) => {
      // Trigger entrance animation for group items if needed.
      const items = banner.querySelectorAll('.cart-item');
      items.forEach((item, index) => {
        item.style.setProperty('--item-index', index);
        item.classList.add('vd-item--ready');
      });
      
      // Update any JS-driven progress markers if applicable.
      const itemCount = parseInt(banner.dataset.itemCount || '0', 10);
      const progressBarFill = banner.querySelector('.vd-progress-fill');
      if (progressBarFill) {
        const nextTarget = parseInt(progressBarFill.dataset.nextQty || '0', 10);
        if (nextTarget > 0) {
          const percentage = Math.min((itemCount / nextTarget) * 100, 100);
          progressBarFill.style.width = percentage + '%';
        }
      }
    });
  }

  // Run on initial load.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVolumeDiscountBanners);
  } else {
    initVolumeDiscountBanners();
  }

  /**
   * Shopify Theme Editor event: runs when a section is re-rendered in the customize view.
   */
  document.addEventListener('shopify:section:load', (event) => {
    if (event.detail.sectionId === 'cart-drawer' || event.target.id.includes('cart-drawer')) {
      initVolumeDiscountBanners();
    }
  });

  /**
   * Listen for Dawn's cart re-render completion.
   * CartDrawer and CartItems in cart.js publish updates that can trigger re-checks.
   */
  if (window.pubsub) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Re-initialize after AJAX cart updates.
      // Since Dawn re-renders the entire HTML content of the drawer, 
      // the banners are replaced. We need to wait for the DOM to be ready.
      setTimeout(initVolumeDiscountBanners, 100);
    });
  }
})();
